import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';

import { TipoTecnico } from './tipos-tecnico.model';

@Injectable({
  providedIn: 'root'
})
export class TiposTecnicoService {
  url: string;

  constructor(private http: HttpClient) {}

  getTiposTecnico(): Observable<TipoTecnico[]> {
    return this.http.get<TipoTecnico[]>(`${this.url}/tiposTecnico/`);
  }

  private getTiposTecnicoMock(): Observable<TipoTecnico[]> {
    let listaTipoTecnico = [
      {
        id: 1,
        nombre: 'Técnico Responsable'
      },
      {
        id: 2,
        nombre: 'Analista de laboratorio'
      },
      {
        id: 3,
        nombre: 'Muestreador'
      }
    ];
    return of(listaTipoTecnico);
  }
}
